import { useTranslation } from 'react-i18next'
import { Header, Info, InfoList, Wrapper } from './_styles'
import {
  getWineGeoIndicationString,
  getWineGrapeVarietiesStrings,
  getWineNationalGITypeString,
  getWineRegionGI,
} from 'utils/wine'
import ChemicalAnalisys from '../ChemicalAnalisys'
import { formatDate } from 'utils/date'
import { formatIngredient } from 'utils/format'

const FirstColumn = ({ product }) => {
  const { t } = useTranslation()

  const wine = product?.wine

  const nationalGIType = getWineNationalGITypeString(wine)
  const geoIndicationsText = getWineGeoIndicationString(wine)
  const region = getWineRegionGI(wine)

  const grapeVarieties = getWineGrapeVarietiesStrings(wine)

  const certifications = wine?.certs ?? []
  const ingredients = wine?.ingredients ?? []

  const closureType = product?.closureType?.localizedName ?? ''
  const bottlingDate = product?.bottlingDate ?? ''

  const formattedDate = bottlingDate
    ? formatDate(new Date(bottlingDate), 'dd.MM.yyyy')
    : ''
  const annualProduction = product?.annualProduction

  return (
    <Wrapper>
      {region && (
        <>
          <Header>{t('wine.techlist.wineRegion')}</Header>
          <InfoList>
            <Info>{region}</Info>
          </InfoList>
        </>
      )}
      {(geoIndicationsText || nationalGIType) && (
        <>
          <Header>{t('wine.techlist.geoIndication')}</Header>
          <InfoList>
            <Info>
              {geoIndicationsText} {nationalGIType}
            </Info>
          </InfoList>
        </>
      )}

      {grapeVarieties.length > 0 && (
        <>
          <Header>{t('wine.techlist.grapeVariety')}</Header>
          <InfoList>
            {grapeVarieties.map((line, idx) => (
              <Info key={idx}>{line}</Info>
            ))}
          </InfoList>
        </>
      )}

      {ingredients.length > 0 && (
        <>
          <Header>{t('wine.techlist.ingredients')}</Header>
          <InfoList>
            {ingredients.map(ingredient => (
              <Info key={ingredient?.id} highlight={ingredient.isAllergen}>
                {formatIngredient(ingredient)}
              </Info>
            ))}
          </InfoList>
        </>
      )}

      {certifications.length > 0 && (
        <>
          <Header>{t('wine.techlist.certifications')}</Header>
          <InfoList>
            {certifications.map(item => (
              <Info key={item?.id}>{item?.localizedName}</Info>
            ))}
          </InfoList>
        </>
      )}

      {closureType && (
        <>
          <Header>{t('wine.techlist.closureType')}</Header>
          <InfoList>
            <Info>{closureType}</Info>
          </InfoList>
        </>
      )}
      {bottlingDate && (
        <>
          <Header>{t('wine.techlist.bottlingDate')}</Header>
          <InfoList>
            <Info>{formattedDate}</Info>
          </InfoList>
        </>
      )}

      {annualProduction && (
        <>
          <Header>{t('wine.techlist.annualProduction')}</Header>
          <InfoList>
            <Info>
              {annualProduction?.value ?? '-'}{' '}
              {annualProduction?.unit?.localizedName ?? ''}
            </Info>
          </InfoList>
        </>
      )}

      <ChemicalAnalisys product={product} />
    </Wrapper>
  )
}

export default FirstColumn
